"use strict";

// see ReactDOMComponentFlags

var React3ComponentFlags = {
  hasCachedChildMarkups: 1 << 0
};

module.exports = React3ComponentFlags;


//////////////////
// WEBPACK FOOTER
// ./~/react-three-renderer/lib/React3ComponentFlags.js
// module id = 104
// module chunks = 110308036455227 195351340454287